// Extend window object for custom animation frame properties
declare global {
  interface Window {
    requestAnimFrame: (callback: FrameRequestCallback) => number;
    webkitRequestAnimationFrame?: (callback: FrameRequestCallback) => number;
    mozRequestAnimationFrame?: (callback: FrameRequestCallback) => number;
  }
}

const clientScrolled = () => {
  const doc = document.documentElement;
  const x = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  const y = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  return {
    x: x,
    y: y,
  };
};

type EasingType = "easeOutSine" | "easeInOutSine" | "easeInOutQuint";

const scrollY = (scrollTargetY: number, speed: number, easing?: EasingType) => {
  window.requestAnimFrame = (function () {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60);
      }
    );
  })();
  const scrollY = window.scrollY || document.documentElement.scrollTop;
  let currentTime = 0;
  easing = easing || "easeOutSine";
  speed = speed || 2000;
  scrollTargetY = scrollTargetY || 0;
  const time = Math.max(
    0.1,
    Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8),
  );
  const easingEquations: Record<EasingType, (pos: number) => number> = {
    easeOutSine: function (pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: function (pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: function (pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2);
    },
  };
  function tick() {
    currentTime += 1 / 60;
    const p = currentTime / time;
    const t = easingEquations[easing!](p);
    if (p < 1) {
      window.requestAnimFrame(tick);
      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }
  tick();
};

export const scrollIntoView = (e: React.MouseEvent | null, eleID: string, offsetTop?: { offsetTop?: number }) => {
  e && e.preventDefault();
  const elementToScrollTo = document.getElementById(eleID);
  if (!elementToScrollTo) return;
  
  const scrollDistance =
    elementToScrollTo.getBoundingClientRect().top +
    clientScrolled().y -
    (offsetTop?.offsetTop ? offsetTop.offsetTop : 0);
  scrollY(scrollDistance, 100);
};
